module.exports = __webpack_public_path__ + "img/logo-en.e655453d.svg";